import { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { SaldoBadge } from './SaldoBadge';
import { WhatsAppSuporte } from './WhatsAppSuporte';
import { AvisoTelefonesSuporte } from './AvisoTelefonesSuporte';
import { useSuporteWhatsApp } from '../hooks/useSuporteWhatsApp';

interface MenuProps {
  isOpen: boolean;
  onClose: () => void;
  onLogout: () => void;
}

export function Menu({ isOpen, onClose, onLogout }: MenuProps) {
  const menuRef = useRef<HTMLDivElement>(null);
  const { user } = useAuth();
  const { telefone: telefoneSuporte, mensagem: mensagemSuporte, avisoTelefones } = useSuporteWhatsApp();

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        onClose();
      }
    }

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
      return () => document.removeEventListener('mousedown', handleClickOutside);
    }
    return undefined;
  }, [isOpen, onClose]);  

  if (!isOpen) {
    return null;
  }

  return (
    <>
      <div
        ref={menuRef}
        className="absolute top-16 left-0 w-56 bg-white rounded-lg shadow-lg py-1 z-50"
      >
        {/* Saldo e WhatsApp só aparecem aqui no mobile; no desktop ficam na navbar */}
        <div className="sm:hidden px-4 py-2 flex flex-col gap-2">
          <SaldoBadge className="rounded-full px-4 py-1 text-center" />
          {telefoneSuporte && avisoTelefones && (
            <AvisoTelefonesSuporte className="flex rounded-lg px-3 py-2 text-xs" />
          )}
          {telefoneSuporte && (
            <WhatsAppSuporte
              telefone={telefoneSuporte}
              mensagem={mensagemSuporte}
              className="rounded-full px-4 py-1 text-sm justify-center"
              onClick={onClose}
            />
          )}
        </div>
        <div className="sm:hidden my-1 border-t border-gray-200" />
        <Link
          to="/home"
          className="block w-full px-4 py-2 text-left text-gray-700 hover:bg-gray-100"
          onClick={onClose}
        >
          Home
        </Link>         
        <Link 
          to="/imprimir-chassi"
          className="block w-full px-4 py-2 text-left text-gray-700 hover:bg-gray-100"
          onClick={onClose}
        >
          Imprimir Chassis
        </Link>
        <div className="my-1 border-t border-gray-200" />
        {user?.tipo === 'admin' && (
          <>
            <Link 
              to="/montadoras"
              className="block w-full px-4 py-2 text-left text-gray-700 hover:bg-gray-100"
              onClick={onClose}
            >
              Montadoras
            </Link>
            <Link 
              to="/fontes"
              className="block w-full px-4 py-2 text-left text-gray-700 hover:bg-gray-100"
              onClick={onClose}
            >
              Fontes
            </Link>
            <div className="my-1 border-t border-gray-200" />
          </>
        )}
        {(user?.tipo === 'admin' || user?.tipo === 'revenda') && (
          <>
            <Link 
              to="/usuarios"
              className="block w-full px-4 py-2 text-left text-gray-700 hover:bg-gray-100"
              onClick={onClose}
            >
              Usuários
            </Link>            
            <div className="my-1 border-t border-gray-200" />
          </>
        )}
        <button 
          onClick={onLogout}
          className="w-full px-4 py-2 text-left text-red-600 hover:bg-gray-100"
        >
          Sair
        </button>
      </div>      
    </>
  );  
}